import styled from 'styled-components';
import { Typography } from 'design-system/src/components/Typography/Typography';
import { PageContainer } from './styles';
import { SuccessCard } from 'design-system/src/components/SuccessCard/SuccessCard';
import { ReturnToHomePageButton } from './ReturnToHomePageButton';

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export type SignupSuccessProps = {
  className?: string;
};

export const SignupSuccess = ({ className }: SignupSuccessProps) => {
  return (
    <PageContainer className={className}>
      <SuccessCard data-fs-unmask="true">
        <StyledContent>
          <Typography styledAs="h6" renderedAs="h1">
            Thank you for your interest! We'll be in touch soon for next steps.
          </Typography>
          <ReturnToHomePageButton />
        </StyledContent>
      </SuccessCard>
    </PageContainer>
  );
};

export default SignupSuccess;
